// This file is generated by a script. Do not edit this file directly.
import React from 'react';
import { cva } from 'cva';
import { Icon } from "../Icon";
import { Heading } from "../Typography";
var mapIconToStatus = function mapIconToStatus(status) {
  switch (status) {
    case 'info':
      return 'InfoSolid';
    case 'success':
      return 'SuccessSolid';
    case 'warning':
      return 'WarningSolid';
    case 'error':
      return 'FailedSolid';
    case 'neutral':
      return 'ToDo';
    case 'highlight':
      return 'New';
    default:
      return 'ToDo';
  }
};
var statusClassNames = cva({
  base: 'cop-rounded-full cop-px-3 cop-w-fit cop-py-0.5',
  variants: {
    status: {
      info: 'cop-text-info cop-bg-info',
      success: 'cop-text-success cop-bg-success',
      warning: 'cop-text-warning cop-bg-warning',
      error: 'cop-text-error cop-bg-error',
      neutral: 'cop-text-primary cop-bg-secondary',
      highlight: 'cop-text-highlight cop-bg-highlight'
    },
    showIcon: {
      "true": 'cop-flex cop-gap-1.5 cop-items-center',
      "false": ''
    }
  },
  defaultVariants: {
    showIcon: false,
    status: 'neutral'
  }
});
export var Status = function Status(_ref) {
  var label = _ref.label,
    _ref$status = _ref.status,
    status = _ref$status === void 0 ? 'neutral' : _ref$status,
    _ref$showIcon = _ref.showIcon,
    showIcon = _ref$showIcon === void 0 ? false : _ref$showIcon,
    className = _ref.className,
    icon = _ref.icon;
  return /*#__PURE__*/React.createElement("div", {
    className: statusClassNames({
      status: status,
      showIcon: showIcon,
      className: className
    })
  }, showIcon ? /*#__PURE__*/React.createElement(Icon, {
    icon: icon !== null && icon !== void 0 ? icon : mapIconToStatus(status),
    className: "cop-h-2.5 cop-w-2.5"
  }) : null, /*#__PURE__*/React.createElement(Heading, {
    size: "sm"
  }, label));
};
